export default {
  title: 'Creative List',
  playableTitle: 'Playable',
  materialTitle: 'Image & Video',
  materialType: {
    image: 'Images',
    video: 'video',
  },
  content: {
    prepend:
      'Listed are the creatives produced by Mindworks, and you can choose to apply them on Mintegral directly. After successfully applied, the creative will be directly uploaded to the creative monitor of your',
    append: '.',
  },
  selfService: 'Mintegral Advertiser Self-service Platform',
  searchFilterLabel: {
    search: 'Search',
    productName: 'Product Name',
    templateName: 'Creative Concept Name',
    templateId: 'Creative Concept ID',
    materialName: 'Project Name',
    materialId: 'Project ID',
    versionName: 'Version Name',
    dcoId: 'DCO ID',
    network: 'Network',
  },
  batchPush: 'Batch Apply',
  playableType: {
    normal: 'General Creation',
    dco: 'DCO Playable',
  },
  table: {
    column: {
      playableName: 'Product Name / Template Name',
      versionCount: 'Ver. Count',
      materialType: 'Type',
      language: 'Language',
      network: 'Networks',
      platform: 'Platform',
      options: 'Operations',
      versionName: 'Version name',
      deliveryTime: 'Delivery Date',
      dcoId: 'DCOID',
      materialName: 'Product Name / Template ID',
      hideVersion: 'Show Less',
      showVersion: 'Show More',
    },
    loadMore: 'Show more',
  },
}
